.sn-call-to-action-type-3 {
  .call-to-action-type-11__content {
    border: none;
    border-radius: 1rem;
    overflow: visible;
    background-color: $color-brand-primary-darkest;
    color: $color-neutral-white;
    text-align: center;
  }

  .call-to-action-type-11__intro {
    &-inner {
      padding: var(--spacing-5xl) 0;

      @include below($breakpoint-desktop) {
        padding: var(--spacing-3xl);
      }
    }
  }

  .me-text--label {
    display: block;
    margin-bottom: map-get($spacings, md);
    text-transform: uppercase;
    letter-spacing: 3px;
    font-size: map-get($font-sizes, xs);
    font-weight: map-get($font-weights, bold);
  }

  .me-heading {
    margin-bottom: map-get($spacings, 2xl);
  }
}
